import React, { useContext } from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';

import FooterContext from '../service/FooterContext';
import LogoImage from '../shared/LogoImage';
import MenuLinks from '../shared/MenuLinks';
import SocialMediaLinks from '../shared/SocialMediaLinks';
import themeStyles from '../Footer.styles';

const Row = themeStyles.apply(Box, 'Row');
const Column = themeStyles.apply(Box, 'Column');
const MainContainer = themeStyles.apply(Box, 'MainContainer');

const MenuMain = () => {
  const {
    navigationItems,
    socialMediaSection,
    socialMenuAtMain,
    logoAtMain,
    styles,
    numberOfFooterColumn,
    footerColumnsGap,
  } = useContext(FooterContext);

  const limitedNavigationitems = numberOfFooterColumn
    ? navigationItems?.items?.slice(0, numberOfFooterColumn)
    : navigationItems?.items;

  return (
    <MainContainer data-testid="cy-footer-categories" styles={styles.mainContainer}>
      <Row>
        <Optional when={logoAtMain}>
          <Column data-testid="cy-footer-logo" noFlex flexGrow={1}>
            <LogoImage />
          </Column>
        </Optional>
        {limitedNavigationitems?.map(items => (
          <Column columnGap={footerColumnsGap} key={items?.itemId} data-testid="cy-footer-column">
            <MenuLinks data={items} />
          </Column>
        ))}
        <Optional when={socialMenuAtMain}>
          <Column>
            <SocialMediaLinks data={socialMediaSection} />
          </Column>
        </Optional>
      </Row>
    </MainContainer>
  );
};

export default MenuMain;
